import React from "react";
import { t } from "../../../helpers/translator";
import CountDownComponent from "../countDownClock";
import Config from "../../../config/main";
import { CloseIdlePopup } from "../../../actions/ui";

export default function inactiveTerminal() {

    return this.props.idlePopupOpen ? <div
        className="popup-m"
        onClick={() => this.props.dispatch(CloseIdlePopup())}
    >
        <div className="mini-box-popup">
            <div className="align-wrapper">
                <div className="ver-center-view-b">
                    <div className="title-popup-page-m">
                        <button className="popup-closed-b" onClick={() => this.props.dispatch(CloseIdlePopup())} />
                    </div>
                    <div className="popup-content-view-m timer-visible">
                        <div className="mini-box-popup">
                            <div className="ticket-results-view-p inactive-popup">
                                {
                                    Config.enableLogoOnPopups && <div className="mini-logo-container"></div>
                                }

                                <CountDownComponent second={60} sendEventToBack={true} />

                                <p>{t(`Terminal is inactive and will be reloaded.`)}</p>
                                <p className='taki-text'>{t(`To activate the terminal touch the screen.`)}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div> : null;
}